import Loadable from 'react-loadable';

export const AlertContainer = Loadable({
  loader: () => import('./AppAlert'),
  loading: () => null,
});


// WEBPACK FOOTER //
// ./src/containers/Shared/index.ts